module.exports = __webpack_public_path__ + "img/1595275634.23f664e1.jpg";